import {
  SyncOutlined, TagOutlined, LeftOutlined, RightOutlined
} from '@ant-design/icons';
import {
  Button, Carousel, Tooltip
} from 'antd';
import chunk from 'lodash/chunk';
import dynamic from 'next/dynamic';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { useClientFetch } from '@lib/request';
import { buildUrl } from '@lib/string';
import { performerService } from '@services/performer.service';
import PerformerCard from '../card/card';
import style from './home-listing.module.scss';

export function HomePerformers() {
  const [isFreeSubscription, setIsFree] = useState('') as any;
  const [refresh, setRefresh] = useState(false);
  const user = useSelector((state: any) => state.user.current);
  const carouselRef = useRef(null) as any;

  const {
    data, isLoading, mutate
  } = useClientFetch(buildUrl(performerService.randomSearchUrl(), {
    isFreeSubscription,
    refresh
  }));

  const chunkPerformers = chunk((data?.data || []).filter((s) => s?._id !== user?._id), 8);

  return (
    <div className={style['suggestion-bl']}>
      <div className={style['sug-top']}>
        <span className={style['sug-text']}>SUGGESTIONS</span>
        <div className={style['btns-grp']}>
          <Tooltip title="Refresh">
            <Button onClick={() => setRefresh(!refresh)}>
              <SyncOutlined spin={isLoading} />
            </Button>
          </Tooltip>
          <Button onClick={() => carouselRef.current && carouselRef.current.prev()}><LeftOutlined /></Button>
          <Button onClick={() => carouselRef.current && carouselRef.current.next()}><RightOutlined /></Button>
        </div>
      </div>
      {chunkPerformers.length > 0 && (
      <Carousel
        autoplay
        autoplaySpeed={5000}
        adaptiveHeight
        ref={carouselRef}
        swipeToSlide
        arrows={false}
        dots={false}
      >
        {chunkPerformers.map((arr: any, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`newaa_${index}`}>
            {arr.length > 0 && arr.map((p) => <PerformerCard performer={p} key={p._id} />)}
          </div>
        ))}
      </Carousel>
      )}
      {!isLoading && !chunkPerformers.length && <p className="text-center">No profile was found</p>}
    </div>
  );
}

export default HomePerformers;
